<section class="product-pricing-section">
  <div class="container-title">
    {{ 'text_pricing' | dbText }}
  </div>
  <div class="pricing-form-container" [formGroup]="pricingForm">
    <div class="price-input-wrapper">
      <div class="price-field-container">
        <div class="price-field">
          <div class="field-label">
            {{ 'text_price' | dbText }}
          </div>
          <input class="ds-input"
                 [class.disabled]="hasAttributes"
                 appCurrencyMask
                 [symbol]="currencySymbol.symbol"
                 [placeholder]="currencySymbol.symbol + ' 0.00'"
                 type="text"
                 formControlName="price">
        </div>
      </div>
      <div class="sale-price-field-container">
        <div class="field-label">
          {{ 'text_salePrice' | dbText }}
        </div>
        <input class="ds-input"
               type="text"
               [class.disabled]="hasAttributes"
               [placeholder]="currencySymbol.symbol + ' 0.00'"
               appCurrencyMask
               [symbol]="currencySymbol.symbol"
               formControlName="sale_price">
      </div>
    </div>
    <div class="charge-tax-container">
      <input type="checkbox"
             class="ds-checkbox"
             id="charge-tax"
             formControlName="charge_tax">
<!--      <label for="charge-tax" class="ds-checkbox-label green">-->
<!--        Charge tax on this product-->
<!--        <i class="db-icon db-icon-info-lined"-->
<!--           [dsTooltip]="'text_addProductLongDesc'|dbText"-->
<!--           dsTooltipPosition="right"-->
<!--           dsTooltipColor="black"-->
<!--           dsTooltipAlign="top"></i>-->
<!--      </label>-->
    </div>
<!--    <div class="tax-percent-field-container"-->
<!--         *ngIf="false">-->
<!--      <div class="field-label">-->
<!--        Tax Percent-->
<!--      </div>-->
<!--      <input class="ds-input"-->
<!--             placeholder="0.00"-->
<!--             type="text"-->
<!--             formControlName="tax_percent">-->
<!--    </div>-->
  </div>
</section>

